export default "<span class=\"grouped {{class}}\" {{attrIfValue \"id\" id}}>\n    {{> @partial-block }}\n</span>";